<template>
  <el-container class="admin-container" :class="{ 'dark-mode': isDarkMode }">
    <el-aside :width="isCollapse ? '64px' : '200px'">
      <div class="logo">
        <template v-if="!isCollapse">
          <el-dropdown @command="handleGroupChange" trigger="click">
            <span class="el-dropdown-link group-dropdown-link">
              <el-icon>
                <ChatDotRound />
              </el-icon>
              <span class="group-title">{{ currentGroupName }}</span>
              <el-icon>
                <ArrowDown />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="group in groups" :key="group.groupid" :command="group.groupid">
                  {{ group.grouptitle }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
        <template v-else>
          <el-icon>
            <ChatDotRound />
          </el-icon>
        </template>
      </div>
      <el-menu :default-active="activeTab" class="el-menu-vertical" :collapse="isCollapse"
        :background-color="isDarkMode ? '#1f2d3d' : '#001529'" :text-color="isDarkMode ? '#b4b4b4' : '#fff'"
        :active-text-color="isDarkMode ? '#ffd04b' : '#ffd04b'" @select="handleSelect">
        <el-menu-item v-if="allowedMenus.includes('dashboard')" index="dashboard">
          <el-icon>
            <IconMenu />
          </el-icon>
          <template #title>仪表盘</template>
        </el-menu-item>
        <el-menu-item v-if="allowedMenus.includes('botmanager')" index="botmanager">
          <el-icon>
            <Cpu />
          </el-icon>
          <template #title>机器人管理</template>
        </el-menu-item>
        <el-menu-item v-if="allowedMenus.includes('autoreply')" index="autoreply">
          <el-icon>
            <ChatDotRound />
          </el-icon>
          <template #title>自动回复</template>
        </el-menu-item>
        <el-menu-item v-if="allowedMenus.includes('carousel')" index="carousel">
          <el-icon>
            <PictureRounded />
          </el-icon>
          <template #title>轮播广告</template>
        </el-menu-item>
        <!-- 积分家族折叠菜单 -->
        <div
          v-if="allowedMenus.includes('pointshis') || allowedMenus.includes('pointsmanager') || allowedMenus.includes('pointsexchange')"
          class="custom-submenu">
          <div class="submenu-header" @click="togglePointsFamily" :class="{ 'is-open': isPointsFamilyOpen }">
            <el-icon>
              <Wallet />
            </el-icon>
            <span>积分家族</span>
            <el-icon class="arrow-icon">
              <ArrowDown />
            </el-icon>
          </div>
          <div class="submenu-content" v-show="isPointsFamilyOpen">
            <div v-if="allowedMenus.includes('pointshis')" class="submenu-item" @click="handleSelect('pointshis')">
              <el-icon>
                <Clock />
              </el-icon>
              <span>积分日志</span>
            </div>
            <div v-if="allowedMenus.includes('pointsmanager')" class="submenu-item"
              @click="handleSelect('pointsmanager')">
              <el-icon>
                <Setting />
              </el-icon>
              <span>积分管理</span>
            </div>
            <div v-if="allowedMenus.includes('pointsexchange')" class="submenu-item"
              @click="handleSelect('pointsexchange')">
              <el-icon>
                <Refresh />
              </el-icon>
              <span>积分兑换</span>
            </div>
            <div v-if="allowedMenus.includes('replypoints')" class="submenu-item" @click="handleSelect('replypoints')">
              <el-icon>
                <ChatLineRound />
              </el-icon>
              <span>积分回复</span>
            </div>
          </div>
        </div>
        <el-menu-item v-if="allowedMenus.includes('invitation')" index="invitation">
          <el-icon>
            <User />
          </el-icon>
          <template #title>邀请活动</template>
        </el-menu-item>
        <el-menu-item v-if="allowedMenus.includes('membermanager')" index="membermanager">
          <el-icon>
            <UserFilled />
          </el-icon>
          <template #title>成员管理</template>
        </el-menu-item>
        <el-menu-item v-if="allowedMenus.includes('pointsdice')" index="pointsdice">
          <el-icon>
            <Timer />
          </el-icon>
          <template #title>骰子游戏</template>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <div class="header-left">
          <el-icon @click="toggleCollapse" :class="{ 'is-active': isCollapse }" style="cursor: pointer;">
            <Fold />
          </el-icon>
          <breadcrumb :items="['首页', activeTab]"></breadcrumb>
        </div>
        <div class="header-right">
          <el-popover v-model:visible="showThemePopover" trigger="click" :width="300" placement="bottom-end">
            <template #reference>
              <el-button class="theme-button" :class="{ active: showThemePopover }" circle>
                <el-icon>
                  <Sunny />
                </el-icon>
              </el-button>
            </template>
            <div class="theme-popover">
              <h4 class="theme-title">选择主题</h4>
              <div class="theme-grid">
                <div v-for="(theme, name) in themes" :key="name" class="theme-item"
                  :class="{ active: currentTheme === name }" @click="setTheme(name)">
                  <div class="theme-preview" :style="{
                    '--theme-primary': theme.primary,
                    '--theme-bg': theme.background
                  }">
                    <div class="preview-header" />
                    <div class="preview-sidebar" />
                  </div>
                  <span class="theme-name">{{ formatThemeName(name) }}</span>
                </div>
              </div>
            </div>
          </el-popover>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <el-avatar size="default" :src="userAvatar" />
              {{ username }}<el-icon class="el-icon--right">
                <ArrowDown />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <!-- <el-dropdown-item command="settings">账户设置</el-dropdown-item> -->
                <el-dropdown-item command="logout">登出</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
      <el-main>
        <div class="main-content">
          <el-card class="main-card">
            <el-tabs v-model="activeTab" type="card" closable @tab-remove="removeTab" class="tabs-bar">
              <el-tab-pane v-for="tab in openedTabs" :key="tab.key" :label="tab.title" :name="tab.key"
                :closable="tab.key !== 'dashboard'" />
            </el-tabs>
            <div class="tab-content-area">
              <component ref="dashboardRef" :is="getComponent(activeTab)" @user-updated="fetchUserInfo"
                @group-selected="onGroupSelected">
              </component>
            </div>
          </el-card>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Document, User, Timer, Setting, Fold, ArrowDown, Phone, Sunny, Menu as IconMenu, ChatDotRound, Cpu, PictureRounded, UserFilled, Wallet, Clock, Refresh, ChatLineRound } from '@element-plus/icons-vue'
import api from '@/services/api';
import { mapActions, mapGetters, mapState } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb.vue';
import UserInfo from '@/components/UserInfo.vue';
import Dashboard from '@/components/Dashboard.vue'
import AutoReply from '@/components/AutoReply.vue'
import BotManager from '@/components/BotManager.vue'
import CarouselComponent from '@/components/Carousel.vue'
import Invitation from '@/components/Invitation.vue'
import PointsManager from '@/components/PointsManager.vue'
import PointsExchange from '@/components/PointsExchange.vue'
import PointsDice from '@/components/PointsDice.vue'
import PointHis from '@/components/PointHis.vue'
import MemberManager from '@/components/MemberManager.vue'
import ReplyPoints from '@/components/ReplyPoints.vue'

const TAB_CONFIG = {
  dashboard: { key: 'dashboard', title: '仪表盘', component: Dashboard, breadcrumb: ['首页', '仪表盘'] },
  botmanager: { key: 'botmanager', title: '机器人管理', component: BotManager, breadcrumb: ['首页', '机器人管理'] },
  autoreply: { key: 'autoreply', title: '自动回复', component: AutoReply, breadcrumb: ['首页', '自动回复'] },
  carousel: { key: 'carousel', title: '轮播广告', component: CarouselComponent, breadcrumb: ['首页', '轮播广告'] },
  pointshis: { key: 'pointshis', title: '积分日志', component: PointHis, breadcrumb: ['首页', '积分日志'] },
  invitation: { key: 'invitation', title: '邀请活动', component: Invitation, breadcrumb: ['首页', '邀请活动'] },
  membermanager: { key: 'membermanager', title: '成员管理', component: MemberManager, breadcrumb: ['首页', '成员管理'] },
  pointsmanager: { key: 'pointsmanager', title: '积分管理', component: PointsManager, breadcrumb: ['首页', '积分管理'] },
  pointsexchange: { key: 'pointsexchange', title: '积分兑换', component: PointsExchange, breadcrumb: ['首页', '积分兑换'] },
  pointsdice: { key: 'pointsdice', title: '骰子游戏', component: PointsDice, breadcrumb: ['首页', '骰子游戏'] },
  userInfo: { key: 'userInfo', title: '用户信息', component: UserInfo, breadcrumb: ['首页', '用户信息'] },
  replypoints: { key: 'replypoints', title: '积分回复', component: ReplyPoints, breadcrumb: ['首页', '积分回复'] }
}

export default {
  name: 'Admin',
  components: {
    Breadcrumb,
    UserInfo,
    Dashboard,
    AutoReply,
    Invitation,
    MemberManager,
    PointsManager,
    PointsExchange,
    PointsDice,
    Document,
    User,
    Timer,
    Setting,
    Fold,
    ArrowDown,
    Phone,
    Sunny,
    IconMenu,
    ChatDotRound,
    Cpu,
    PictureRounded,
    UserFilled,
    Wallet,
    Clock,
    Refresh,
    ChatLineRound
  },
  data() {
    return {
      username: '',
      userId: '',
      userRole: null,
      activeTab: 'dashboard',
      isDarkMode: false,
      isCollapse: false,
      showThemePopover: false,
      showAccountDialog: false,
      accountForm: {
        username: '',
        currentPassword: '',
        newPassword: ''
      },
      openedTabs: [TAB_CONFIG.dashboard],
      groups: [],
      currentGroupId: localStorage.getItem('groupId') || null,
      isPointsFamilyOpen: false // 新增：控制积分家族折叠菜单的展开状态
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    ...mapGetters('theme', ['currentTheme', 'themes']),
    allowedMenus() {
      const role = Number(this.userRole);
      switch (role) {
        case 0: // admin
          return ['dashboard', 'botmanager', 'autoreply', 'carousel', 'pointshis', 'invitation', 'membermanager', 'pointsmanager', 'pointsexchange', 'pointsdice', 'replypoints'];
        case 1: // 前后端客服
          return ['dashboard', 'botmanager', 'autoreply', 'carousel', 'pointshis', 'invitation', 'membermanager', 'pointsmanager', 'pointsexchange', 'pointsdice', 'replypoints'];
        case 2: // 后端技术
          return ['dashboard', 'botmanager', 'autoreply', 'carousel', 'pointshis', 'invitation', 'membermanager', 'pointsmanager', 'pointsexchange', 'pointsdice', 'replypoints'];
        default:
          return [];
      }
    },
    userAvatar() {
      if (this.currentUser && this.currentUser.telegram && this.currentUser.telegram.photo_url) {
        return this.currentUser.telegram.photo_url;
      }
      return 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
    },
    currentGroupName() {
      if (this.groups.length === 0) {
        console.log('[currentGroupName] groups为空，显示暂无群组');
        return '暂无群组';
      }
      const group = this.groups.find(g => g.groupid == this.currentGroupId);
      if (!group) {
        return '尚未选择群组';
      }
      // console.log('[currentGroupName] 当前群:', group);
      return group.grouptitle;
    },
    currentComponent() {
      if (!this.activeTab) return null;
      if (!this.allowedMenus.includes(this.activeTab) && this.activeTab !== 'userInfo') {
        this.$nextTick(() => {
          const defaultPage = this.allowedMenus[0];
          if (defaultPage) {
            this.$router.push(`/${defaultPage}`);
            this.activeTab = defaultPage;
          }
        });
        return null;
      }
      switch (this.activeTab) {
        case 'dashboard':
          return Dashboard;
        case 'autoreply':
          return AutoReply;
        case 'carousel':
          return CarouselComponent;
        case 'invitation':
          return Invitation;
        case 'pointsmanager':
          return PointsManager;
        case 'pointsexchange':
          return PointsExchange;
        case 'pointsdice':
          return PointsDice;
        case 'userInfo':
          return UserInfo;
        default:
          return null;
      }
    },
    defaultPage() {
      return this.allowedMenus[0] || 'dashboard';
    }
  },
  methods: {
    ...mapActions(['logout']),
    ...mapActions('theme', ['setTheme']),
    formatThemeName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    handleSelect(key) {
      if (!this.allowedMenus.includes(key) && key !== 'userInfo') {
        this.$message.error('您没有权限访问该页面');
        return;
      }
      const exist = this.openedTabs.find(tab => tab.key === key);
      if (!exist && TAB_CONFIG[key]) {
        this.openedTabs.push(TAB_CONFIG[key]);
      }
      this.activeTab = key;
    },
    removeTab(targetKey) {
      let newTabs = this.openedTabs.filter(tab => tab.key !== targetKey);
      if (this.activeTab === targetKey) {
        const lastTab = newTabs[newTabs.length - 1];
        this.activeTab = lastTab ? lastTab.key : 'dashboard';
      }
      this.openedTabs = newTabs;
    },
    getComponent(key) {
      return TAB_CONFIG[key] ? TAB_CONFIG[key].component : null;
    },
    getBreadcrumb(key) {
      return TAB_CONFIG[key] ? TAB_CONFIG[key].breadcrumb : [];
    },
    async handleCommand(command) {
      if (command === 'logout') {
        await this.handleLogout();
      } else if (command === 'settings') {
        this.accountForm.username = this.username;
        this.accountForm.currentPassword = '';
        this.accountForm.newPassword = '';
        const exist = this.openedTabs.find(tab => tab.key === 'userInfo');
        if (!exist) {
          this.openedTabs.push(TAB_CONFIG['userInfo']);
        }
        this.activeTab = 'userInfo';
        this.showAccountDialog = true;
      }
    },
    async handleLogout() {
      try {
        await this.logout();
        this.$message.success('已退出登录');
        await this.$nextTick();
        await this.$router.push('/telegram-login');
      } catch (error) {
        console.error('登出失败:', error);
        this.$message.error('登出失败');
      }
    },
    async fetchUserInfo() {
      try {
        // 优先从store中获取用户信息
        if (this.currentUser) {
          this.username = this.currentUser.username;
          this.userId = this.currentUser.id;
          this.userRole = Number(this.currentUser.role);
          // 加载群组列表
          await this.loadGroups();
          return;
        }

        // 如果store中没有，则从API获取
        const response = await api.getUserInfo();
        this.username = response.data.username;
        this.userId = response.data.id;
        this.userRole = Number(response.data.role);
        this.$store.commit('setUser', response.data);
        // 加载群组列表
        await this.loadGroups();
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.$message.error('获取用户信息失败');
      }
    },
    async loadGroups() {
      const telegramUserId = this.$store.state.user?.telegram?.id;
      if (!telegramUserId) return;
      const res = await api.getGroups(telegramUserId);
      this.groups = res.data;
      // console.log('[loadGroups] 加载群组:', this.groups);
      // 首次加载且 currentGroupId 为空，意味着没有选择群id  那么就不应该 随便赋值  必须让用户选择


    },
    handleGroupChange(groupid) {
      this.currentGroupId = groupid;
      localStorage.setItem('groupId', groupid);
      // 更新 store
      const currentUser = this.$store.state.user;
      if (currentUser) {
        this.$store.commit('setUser', { ...currentUser, groupId: groupid });
      }
      // 切换群组时，关闭所有标签页，只保留仪表盘
      this.openedTabs = [TAB_CONFIG.dashboard];
      this.activeTab = 'dashboard';
      // 强制刷新仪表盘数据
      this.$nextTick(() => {
        if (this.$refs.dashboardRef && this.$refs.dashboardRef.refresh) {
          this.$refs.dashboardRef.refresh();
        }
      });
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    async handleChangePassword() {
      if (!this.accountForm.currentPassword || !this.accountForm.newPassword) {
        this.$message.error('请填写完整信息');
        return;
      }
      try {
        await api.updatePassword(this.username, this.accountForm.currentPassword, this.accountForm.newPassword);
        this.$message.success('密码修改成功');
        this.showAccountDialog = false;
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.$message.error(error.response.data.message);
        } else {
          this.$message.error('密码修改失败');
        }
      }
    },
    onGroupSelected(group) {
      console.log('[onGroupSelected] 选中群组:', group);
      this.currentGroupId = group.groupid;
      localStorage.setItem('groupId', group.groupid);
      // 更新 store
      const currentUser = this.$store.state.user;
      if (currentUser) {
        this.$store.commit('setUser', { ...currentUser, groupId: group.groupid });
      }
      // 不刷新页面，左上角群名会自动响应式更新
    },
    togglePointsFamily() {
      this.isPointsFamilyOpen = !this.isPointsFamilyOpen;
    }
  },
  mounted() {
    this.fetchUserInfo();
    this.setTheme(this.currentTheme);
  }
}
</script>

<style scoped>
.admin-container {
  height: 100vh;
  background: var(--main-bg-color, #f6f8fc);
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #2c3e50;
  font-size: 20px;
  font-weight: bold;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-dropdown-link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  cursor: pointer;
}

.group-title {
  font-weight: 600;
  color: #333;
  margin: 0 4px;
  max-width: 140px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  padding: 0 24px;
  min-height: 56px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-right .el-dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-right .el-avatar {
  margin-right: 4px;
}

.el-aside {
  background: var(--sidebar-bg-color, #001529);
  transition: width 0.3s;
}

.el-menu-vertical {
  border-right: none;
  background: var(--sidebar-bg-color, #fff) !important;
}

.el-menu-vertical .el-menu-item {
  color: var(--menu-text-color, #333) !important;
}

.el-menu-vertical .el-menu-item.is-active,
.el-menu-vertical .el-menu-item:hover {
  color: var(--menu-active-text-color, #626aef) !important;
  background: rgba(98, 106, 239, 0.08) !important;
  /* 可根据主题调整 */
}

/* 折叠菜单样式，保持与原有菜单颜色一致 */
.el-menu-vertical .el-sub-menu .el-sub-menu__title {
  color: var(--menu-text-color, #333) !important;
}

.el-menu-vertical .el-sub-menu .el-sub-menu__title:hover {
  color: var(--menu-active-text-color, #626aef) !important;
  background: rgba(98, 106, 239, 0.08) !important;
}

.el-menu-vertical .el-sub-menu .el-menu-item {
  color: var(--menu-text-color, #333) !important;
}

.el-menu-vertical .el-sub-menu .el-menu-item:hover {
  color: var(--menu-active-text-color, #626aef) !important;
  background: rgba(98, 106, 239, 0.08) !important;
}

.el-menu-vertical .el-sub-menu .el-menu-item.is-active {
  color: var(--menu-active-text-color, #626aef) !important;
  background: rgba(98, 106, 239, 0.08) !important;
}

/* 折叠菜单展开时的背景色 */
.el-menu-vertical .el-sub-menu.is-opened>.el-sub-menu__title {
  color: var(--menu-active-text-color, #626aef) !important;
}

/* 深色主题下的折叠菜单样式 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-sub-menu__title {
  color: #b4b4b4 !important;
  background: transparent !important;
}

.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-sub-menu__title:hover {
  color: #ffd04b !important;
  background: rgba(255, 208, 75, 0.1) !important;
}

.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu-item {
  color: #b4b4b4 !important;
  background: transparent !important;
}

.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu-item:hover {
  color: #ffd04b !important;
  background: rgba(255, 208, 75, 0.1) !important;
}

.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu-item.is-active {
  color: #ffd04b !important;
  background: rgba(255, 208, 75, 0.1) !important;
}

.admin-container.dark-mode .el-menu-vertical .el-sub-menu.is-opened>.el-sub-menu__title {
  color: #ffd04b !important;
}

/* 确保折叠菜单在深色主题下有正确的背景 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu {
  background: transparent !important;
}

.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu {
  background: transparent !important;
}

/* 强制覆盖Element Plus的默认深色样式 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-sub-menu__title,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu-item {
  background-color: transparent !important;
}

.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu {
  background-color: transparent !important;
}

/* 折叠菜单展开时的子菜单背景 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu--inline {
  background: transparent !important;
}

/* 确保所有子菜单项都有透明背景 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu-item,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-sub-menu__title {
  background: transparent !important;
}

/* 使用更高优先级的选择器强制覆盖 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-sub-menu__title,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu-item,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu--inline {
  background-color: transparent !important;
  background-image: none !important;
}

/* 覆盖可能的伪元素背景 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-sub-menu__title::before,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu__title::after {
  background: transparent !important;
}

/* 确保子菜单容器完全透明 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu--popup {
  background: transparent !important;
}

/* 专门针对积分家族折叠菜单的样式 */
.points-family-submenu {
  background: transparent !important;
}

.points-family-submenu .el-menu {
  background: transparent !important;
}

.points-family-submenu .el-menu-item {
  background: transparent !important;
}

/* 深色主题下的积分家族折叠菜单 */
.admin-container.dark-mode .points-family-submenu,
.admin-container.dark-mode .points-family-submenu .el-menu,
.admin-container.dark-mode .points-family-submenu .el-menu-item,
.admin-container.dark-mode .points-family-submenu .el-sub-menu__title {
  background: transparent !important;
  background-color: transparent !important;
}

/* 强制覆盖Element Plus的默认样式 */
.admin-container.dark-mode .points-family-submenu .el-menu--inline {
  background: transparent !important;
}

.admin-container.dark-mode .points-family-submenu .el-sub-menu__title {
  background: transparent !important;
}

/* 使用最高优先级的选择器 */
.admin-container.dark-mode .points-family-submenu * {
  background: transparent !important;
  background-color: transparent !important;
}

/* 弹出层样式控制 */
.points-family-popup {
  background: transparent !important;
}

.points-family-popup .el-menu {
  background: transparent !important;
}

.points-family-popup .el-menu-item {
  background: transparent !important;
}

/* 深色主题下的弹出层 */
.admin-container.dark-mode .points-family-popup,
.admin-container.dark-mode .points-family-popup .el-menu,
.admin-container.dark-mode .points-family-popup .el-menu-item {
  background: transparent !important;
  background-color: transparent !important;
}

/* 全局强制覆盖Element Plus的折叠菜单样式 */
.admin-container.dark-mode .el-sub-menu,
.admin-container.dark-mode .el-sub-menu .el-menu,
.admin-container.dark-mode .el-sub-menu .el-menu-item,
.admin-container.dark-mode .el-sub-menu .el-sub-menu__title {
  background: transparent !important;
  background-color: transparent !important;
}

/* 使用更具体的选择器 */
.admin-container.dark-mode .el-menu-vertical .el-sub-menu,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu-item,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-sub-menu__title,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu--inline,
.admin-container.dark-mode .el-menu-vertical .el-sub-menu .el-menu--popup {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
}

/* 添加全局样式覆盖，使用最高优先级 */
:deep(.admin-container.dark-mode .el-sub-menu),
:deep(.admin-container.dark-mode .el-sub-menu .el-menu),
:deep(.admin-container.dark-mode .el-sub-menu .el-menu-item),
:deep(.admin-container.dark-mode .el-sub-menu .el-sub-menu__title) {
  background: transparent !important;
  background-color: transparent !important;
}

/* 使用CSS变量强制覆盖 */
.admin-container.dark-mode {
  --el-menu-bg-color: transparent !important;
  --el-menu-hover-bg-color: rgba(255, 208, 75, 0.1) !important;
  --el-menu-active-color: #ffd04b !important;
  --el-menu-text-color: #b4b4b4 !important;
}

.theme-popover {
  padding: 8px 0;
}

.theme-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.theme-item {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.theme-item.active {
  border-color: var(--el-color-primary);
}

.theme-preview {
  width: 36px;
  height: 24px;
  border-radius: 4px;
  background: var(--theme-bg, #fff);
  margin-bottom: 4px;
  border: 1px solid #eee;
  position: relative;
}

.preview-header {
  width: 100%;
  height: 6px;
  background: var(--theme-primary, #626aef);
  border-radius: 4px 4px 0 0;
}

.preview-sidebar {
  width: 8px;
  height: 18px;
  background: #e5e7eb;
  position: absolute;
  left: 0;
  top: 6px;
  border-radius: 0 0 0 4px;
}

.theme-name {
  font-size: 12px;
  color: #888;
}

.main-content {
  padding: 0;
}

.main-card {
  border-radius: 0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.04);
  background: #fff;
  padding: 0;
  max-width: 100%;
}

.tabs-bar {
  margin-bottom: 0;
  background: transparent;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 8px 8px 0 0;
  padding: 0 16px;
}

.tab-content-area {
  padding: 24px 16px 0 16px;
}

/* 自定义积分家族折叠菜单样式 */
.custom-submenu {
  background: transparent !important;
}

.custom-submenu .submenu-header {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 56px;
  cursor: pointer;
  transition: all 0.3s;
  color: var(--menu-text-color, #333);
  position: relative;
}

.custom-submenu .submenu-header:hover {
  background-color: rgba(98, 106, 239, 0.08);
  color: var(--menu-active-text-color, #626aef);
}

.custom-submenu .submenu-header.is-open {
  background-color: rgba(98, 106, 239, 0.08);
  color: var(--menu-active-text-color, #626aef);
}

.custom-submenu .submenu-header .arrow-icon {
  transition: transform 0.3s ease;
  transform: rotate(0deg);
  margin-left: auto;
}

.custom-submenu .submenu-header.is-open .arrow-icon {
  transform: rotate(180deg);
}

.custom-submenu .submenu-content {
  background: transparent;
  padding: 0;
  margin: 0;
  border: none;
  box-shadow: none;
}

.custom-submenu .submenu-item {
  display: flex;
  align-items: center;
  padding: 0 20px 0 40px;
  height: 56px;
  cursor: pointer;
  transition: all 0.3s;
  color: var(--menu-text-color, #333);
  position: relative;
}

.custom-submenu .submenu-item:hover {
  background-color: rgba(98, 106, 239, 0.08);
  color: var(--menu-active-text-color, #626aef);
}

.custom-submenu .submenu-item.is-active {
  background-color: rgba(98, 106, 239, 0.08);
  color: var(--menu-active-text-color, #626aef);
}

/* 确保图标和文字的对齐 */
.custom-submenu .submenu-header .el-icon,
.custom-submenu .submenu-item .el-icon {
  margin-right: 8px;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.custom-submenu .submenu-header span,
.custom-submenu .submenu-item span {
  font-size: 14px;
  line-height: 1;
}

/* 调整积分家族标题图标的对齐 */
.custom-submenu .submenu-header .el-icon {
  margin-right: 8px;
  margin-left: 2px;
  /* 稍微右移，与其他菜单项图标对齐 */
}

/* 深色主题下的自定义折叠菜单样式 */
.admin-container.dark-mode .custom-submenu .submenu-header {
  color: #b4b4b4;
}

.admin-container.dark-mode .custom-submenu .submenu-header:hover,
.admin-container.dark-mode .custom-submenu .submenu-header.is-open {
  background-color: rgba(255, 208, 75, 0.1);
  color: #ffd04b;
}

.admin-container.dark-mode .custom-submenu .submenu-content {
  background-color: transparent;
  border-color: transparent;
}

.admin-container.dark-mode .custom-submenu .submenu-item {
  color: #b4b4b4;
}

.admin-container.dark-mode .custom-submenu .submenu-item:hover {
  background-color: rgba(255, 208, 75, 0.1);
  color: #ffd04b;
}
</style>
